module.exports = __webpack_public_path__ + "static/media/fgp.c1551a75.png";